import { ThemeUICSSObject } from '@apia/theme';

const iframeModal: ThemeUICSSObject = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  overflow: 'hidden',
  width: '100%',

  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
};

export default iframeModal;
